import { render, staticRenderFns } from "./OptionShowDisabledIfTab.vue?vue&type=template&id=2e1b6ace"
import script from "./OptionShowDisabledIfTab.vue?vue&type=script&lang=ts"
export * from "./OptionShowDisabledIfTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports